import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatIconModule } from '@angular/material/icon';

import { UiKitButtonDirective } from './button/button';
import {
  UiKitCardDirective,
  UiKitCardHeaderDirective,
  UiKitCardTabDirective,
  UiKitCardSubheaderDirective
} from './card/card';
import { UiKitAnchorDirective } from './anchor/anchor';
import { UiKitHeadingComponent } from './heading/heading';
import { UiKitInputComponent } from './input/input';
import { UiKitCaptionComponent } from './caption/caption';
import { UiKitLabelComponent } from './label/label';
import { UiKitKeyValueComponent } from './key-value/key-value';

@NgModule({
  declarations: [
    UiKitButtonDirective,
    UiKitCardDirective,
    UiKitCardHeaderDirective,
    UiKitCardTabDirective,
    UiKitCardSubheaderDirective,
    UiKitAnchorDirective,
    UiKitHeadingComponent,
    UiKitInputComponent,
    UiKitLabelComponent,
    UiKitCaptionComponent,
    UiKitKeyValueComponent
  ],
  imports: [CommonModule, MatIconModule],
  exports: [
    UiKitButtonDirective,
    UiKitCardDirective,
    UiKitCardHeaderDirective,
    UiKitCardTabDirective,
    UiKitCardSubheaderDirective,
    UiKitAnchorDirective,
    UiKitHeadingComponent,
    UiKitInputComponent,
    UiKitLabelComponent,
    UiKitCaptionComponent,
    UiKitKeyValueComponent
  ]
})
export class UiKitModule {}
